module.exports = __webpack_public_path__ + "static/mrunalini-9af9f7c1e3bc9f6a9da345196b464902.jpg";